import { Table, Tabs, Space, Input, Button, Pagination, message, Popconfirm } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { userList, updateRole } from "@/apis/user";
import { useEffect } from 'react';

const UserManagement = () => {
	const [params, setParams] = useState({
		keywords: "",
		roleId: 2,
	})
	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [data, setData] = useState([]);
	const [total, setTotal] = useState(0)
	const columns = [
		{
			title: "账号",
			key: 'username',
			dataIndex: 'username',
			render: (text, record) => {
				return <a href="#">{text}</a>
			},
		},
		{
			title: "昵称",
			key: 'nickname',
			dataIndex: 'nickname',
			render: (text, record) => {
				return <a href="#">{text}</a>
			},
		},
		{
			title: "邮箱",
			key: 'email',
			dataIndex: 'email',
		},
		{
			title: "国家",
			key: 'country',
			dataIndex: 'country',
		},
		{
			title: "角色",
			key: 'role',
			dataIndex: 'role',
			render: (text, record) => {
				return <span>{changeRole(record.roleId)}</span>
			},
		},
		{
			title: "分配角色",
			key: 'opreation',
			render: (text, record) => {
				return <div className={styles.btnBox}>
					<Popconfirm
						title="更改为管理员角色权限"
						description="是否确认继续执行此操作?"
						onConfirm={() => distribute(record.uuid, 1)}
						okText="是"
						cancelText="否"
					>
						{record.roleId !== 1 && <Button type="primary" size="small">管理员</Button>}
					</Popconfirm>
					<Popconfirm
						title="更改为普通用户角色权限"
						description="是否确认继续执行此操作?"
						onConfirm={() => distribute(record.uuid, 2)}
						okText="是"
						cancelText="否"
					>
						{record.roleId !== 2 && <Button size="small">普通用户</Button>}
					</Popconfirm>
					<Popconfirm
						title="更改为教师角色权限"
						description="是否确认继续执行此操作?"
						onConfirm={() => distribute(record.uuid, 3)}
						okText="是"
						cancelText="否"
					>
						{record.roleId !== 3 && <Button size="small">教师</Button>}
					</Popconfirm>

					<Popconfirm
						title="更改为学生角色权限"
						description="是否确认继续执行此操作?"
						onConfirm={() => distribute(record.uuid, 4)}
						okText="是"
						cancelText="否"
					>
						{record.roleId !== 4 && <Button size="small">学生</Button>}
					</Popconfirm>
				</div>
			},
		},
	];

	const changeRole = (value) => {
		if (value === 1) {
			return '管理员'
		} else if (value === 2) {
			return '普通用户'
		} else if (value === 3) {
			return '教师'
		} else if (value === 4) {
			return '学生'
		} else {
			return '未知'
		}
	}
	const items = [
		{
			key: null,
			label: '全部',
			children: '',
		},
		{
			key: 2,
			label: '普通用户',
			children: '',
		},
		{
			key: 1,
			label: '管理员',
			children: '',
		}, {
			key: 3,
			label: '教师',
			children: '',
		}, {
			key: 4,
			label: '学生',
			children: '',
		}
	];

	const distribute = (id, role) => {
		updateRole({
			userUuid: id,
			roleId: role
		}).then(res => {
			message.success('修改成功')
			setPageParam({ ...pageParam, currentPage: 1 })
		})
	}

	const onChange = (key) => {
		setParams({ ...params, roleId: key })
		setPageParam({ ...pageParam, currentPage: 1 })
	}

	const getList = () => {
		userList({
			...pageParam,
			...params,
		}).then(res => {
			setData(res.data?.records || [])
			setTotal(res.data?.total || 0)
		})
	}
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			// getList()
			setPageParam({ ...pageParam, currentPage: 1 })
		}
	}

	useEffect(() => {
		getList()
	}, [params.roleId, pageParam])

	return <div className={classNames('container', styles.userBox)}>
		<h3>用户管理</h3>
		<Tabs type="card" defaultActiveKey={2} items={items} onChange={onChange} />
		<Space.Compact className={styles.paramsBox}>
			<Input
				allowClear
				placeholder="账号/邮箱"
				onKeyDown={handleKeyDown}
				onChange={(e) => {
					setParams({ ...params, keywords: e.target.value })
				}} />
			<Button type="primary" onClick={getList}>搜索</Button>
		</Space.Compact>
		<Table rowKey={record => record.uuid} pagination={false} columns={columns} dataSource={data} />
		<Pagination
			align="end"
			style={{ marginTop: "20px" }}
			current={pageParam.currentPage}
			pageSize={pageParam.pageSize}
			total={total}
			showSizeChanger={false}
			showQuickJumper
			onChange={(page, pageSize) => {
				setPageParam({
					currentPage: page,
					pageSize: pageSize,
				});
			}}
		/>
	</div>
}
export default UserManagement;